import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'

const TitleAnnouncer = ({ orientation }) => {
  const [title, setTitle] = React.useState('')
  const titleRef = React.createRef()
  const onHelmetChange = ({ title }) => setTitle(title)

  setTimeout(() => {
    if (orientation === 'mobile') {
      const btnBackPage = document.querySelector(`.btn-back-page`)

      if (btnBackPage) {
        btnBackPage.focus()
      }
    } else {
      const accessibilityMenus = document.getElementById('accessibility-menu-anchors')
      if (accessibilityMenus !== null) {
        accessibilityMenus.setAttribute('tabindex', '0')
        accessibilityMenus.focus()
        accessibilityMenus.addEventListener('blur', function () {
          accessibilityMenus.removeAttribute('tabindex')
        })
        accessibilityMenus.blur()
      }
    }
  }, 500)

  return (
    <Fragment>
      <MediaQuery maxDeviceWidth={1024}>
        <Helmet onChangeClientState={onHelmetChange} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={1025}>
        <div className='hide-absolute' aria-hidden='true'>
          <p
            ref={titleRef}
            className='TitleAnnouncer'
            aria-hidden='true'
          >
            {title}
          </p>
          <Helmet onChangeClientState={onHelmetChange} />
        </div>
      </MediaQuery>
    </Fragment>
  )
}

TitleAnnouncer.propTypes = {
  orientation: PropTypes.string
}

export default TitleAnnouncer



// WEBPACK FOOTER //
// ./src/App/Shell/TitleAnnouncer.js